import { createStyles, Theme } from '@material-ui/core'

export const QuestionsStyles = (theme: Theme) => createStyles({
  root: {
    width: '100%'
  }
})